import React from "react";
import { TableContainer, TableRow, TableCell, TableBody, Table } from "carbon-components-react";

import { formatCurrency } from "@eave/shared/utils/currency";

const styles = require("./styles.module.scss");

interface Props {
  title: string;
  rowData: Row[];
}

interface Row {
  id: string;
  name: React.ReactNode;
  value: number;
  valueStyle?: string;
}

const SimpleTable = ({ title, rowData }: Props) => {
  return (
    <TableContainer className={styles.tableMargin} title={title}>
      <Table size="lg" useZebraStyles>
        <TableBody>
          {rowData.map(row => (
            <TableRow key={row.id}>
              {Object.keys(row)
                .filter(key => key !== "id" && key !== "valueStyle")
                .map(key => {
                  if (key === "value") {
                    return (
                      <TableCell className={row?.valueStyle} key={key}>
                        <strong>{formatCurrency(row[key])}</strong>
                      </TableCell>
                    );
                  }

                  return <TableCell key={key}>{row[key]}</TableCell>;
                })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SimpleTable;
